module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fb-Hc-Ia.503b0b27.png";